import { j as f } from "./atoms-v218.js";
import * as C from "react";
import { useId as h, useCallback as x, useMemo as m } from "react";
import { PresenceContext as j } from "./atoms-v2916.js";
import { useConstant as M } from "./atoms-v2872.js";
import { PopChild as v } from "./atoms-v21061.js";
const y = ({ children: s, initial: u, isPresent: r, onExitComplete: o, custom: c, presenceAffectsLayout: i, mode: p }) => {
  const e = M(w), l = h(), n = x((t) => {
    e.set(t, !0);
    for (const a of e.values())
      if (!a)
        return;
    o && o();
  }, [e, o]), d = m(
    () => ({
      id: l,
      initial: u,
      isPresent: r,
      custom: c,
      onExitComplete: n,
      register: (t) => (e.set(t, !1), () => e.delete(t))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? [Math.random(), n] : [r, n]
  );
  return m(() => {
    e.forEach((t, a) => e.set(a, !1));
  }, [r]), C.useEffect(() => {
    !r && !e.size && o && o();
  }, [r]), p === "popLayout" && (s = f.jsx(v, { isPresent: r, children: s })), f.jsx(j.Provider, { value: d, children: s });
};
function w() {
  return /* @__PURE__ */ new Map();
}
export {
  y as PresenceChild
};
